export class Retry {

    public retry_id: string;
    public retry_number: number = 1;

    constructor(retry_idp) {
        this.retry_id = retry_idp;
    }
}